import * as React from 'react';

import { faEye } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Button } from 'src/registry/ui/Button';
import { Input } from 'src/registry/ui/Input';
import { cn } from 'src/utils/shadcn';

function InputWithPassword({
    type,
    wrapperProps,
    ...props
}: React.ComponentProps<typeof Input> & { wrapperProps?: React.ComponentProps<'div'> }) {
    const [show, setShow] = React.useState<boolean>(false);
    const className = { wrapperProps };

    return (
        <div className={cn('group relative', className)} {...wrapperProps}>
            <Input type={show ? 'text' : type} {...props} />
            <Button
                onClick={() => {
                    setShow((prev) => !prev);
                }}
                type="button"
                variant={show ? 'default' : 'outline-solid'}
                className={cn(
                    'absolute top-1 right-1 size-8 rounded-sm p-0 group-focus-within:block group-hover:block',
                    show ? 'block' : 'sm:hidden',
                )}
            >
                <FontAwesomeIcon icon={faEye} />
            </Button>
        </div>
    );
}

export { InputWithPassword };
